import { Screens } from '@shared/constants/screens';
import { FormState, FormActionType, CDX_ACTIONS } from '../types/form';

export const initialEmploymentFormData = {
  incomeType: '',
  employersName: '',
  jobTitle: '',
  employersAddress: '',
  employersAPTSuiteNumber: '',
  employersZipCode: '',
  employersCity: '',
  employersState: '',
  employersPhoneNumber: '',
  startDate: '',
  isCurrentIncomeSource: false,
  annualIncome: 0,
  endDate: '',
};

export const initialIncomeFormData = {
  incomeType: '',
  otherIncomeSource: '',
  startDate: '',
  isCurrentIncomeSource: false,
  endDate: '',
  monthlyAmount: 0,
};

export const nonEmploymentInitialFormData = {
  incomeType: '',
};

export const initialFormState: FormState = {
  widgetInitVariables: {
    PartnerName: '',
    branding: {
      hideTopNav: false,
      primaryColor: '#00aa8f',
      secondaryColor: '#7b1b17',
      roundCorners: true,
    },
    tracking: {
      extraData: '',
    },
  },
  licensePlateInfoForm: {
    plateNumber: '',
    plateState: '',
    estimatedMileageRange: '',
    currentMonthlyPayment: 0,

  },
  manualLicensePlateInfoForm: {
    year: '',
    make: '',
    makeName: '',
    model: '',
    estimatedMileage: '',
    currentMonthlyPayment: 0,
  },
  verifyYourIdentity: {
    dateOfBirth: '',
    phone: '',
  },
  licensePlateInfoResponse: null,
  verifyYourInformation: {
    firstName: '',
    lastName: '',
    addresses: [],
    phone: '',
    ssn: '',
    dateOfBirth: '',
    email: '',
    residency: '',
  },
  addressHistory: null,
  createContactResponse: null,
  softPullResponse: null,
  offerSelectionFormData: null,
  employmentFormData: initialEmploymentFormData,
  incomeFormData: initialIncomeFormData,
  addressContactResponse: null,
  currentStep: '',
  isLoading: false,
  isSubmitSuccess: false,
  error: null,
  apiError: null,
  progress: 20,
  contactDetails: null,
};

export const formReducer = (state: FormState = initialFormState, action: FormActionType): FormState => {
  switch (action.type) {
    case CDX_ACTIONS.SET_INIT_VALUES:
      return {
        ...state,
        widgetInitVariables: {
          ...state.widgetInitVariables,
          ...action.payload,
          branding: {
            ...state.widgetInitVariables?.branding,
            ...action.payload?.branding,
          },
        },
      };
    case CDX_ACTIONS.SET_STEP:
      return { ...state, currentStep: action.payload };
    case CDX_ACTIONS.RESET_FORM:
      return {
        ...initialFormState,
        currentStep: Screens.ENTER_LICENSE_PLATE,
        widgetInitVariables: { ...state.widgetInitVariables },
      };
    case CDX_ACTIONS.SUBMIT_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CDX_ACTIONS.SUBMIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSubmitSuccess: true,
        apiError: null,
        error: null,
      };
    case CDX_ACTIONS.SUBMIT_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CDX_ACTIONS.SUBMIT_API_ERROR:
      return {
        ...state,
        isLoading: false,
        apiError: action.payload,
      };
    case CDX_ACTIONS.GET_API_ERROR:
      return {
        ...state,
        isLoading: false,
        apiError: action.payload,
      };

    case CDX_ACTIONS.SET_LICENSE_PLATE_INFO_FORM:
      return {
        ...state,
        licensePlateInfoForm: { ...state.licensePlateInfoForm, ...action.payload },
      };

    case CDX_ACTIONS.SET_MANUAL_LICENSE_PLATE_INFO_FORM:
      return {
        ...state,
        manualLicensePlateInfoForm: { ...state.manualLicensePlateInfoForm, ...action.payload },
      };
    case CDX_ACTIONS.SET_VERIFY_YOUR_IDENTITY_FORM:
      return {
        ...state,
        verifyYourIdentity: { ...state.verifyYourIdentity, ...action.payload },
      };

    case CDX_ACTIONS.SET_VERIFY_YOUR_INFORMATION_FORM:
      return {
        ...state,
        verifyYourInformation: {
          ...state.verifyYourInformation,
          ...action.payload,
        },
      };
    case CDX_ACTIONS.SET_EMPLOYMENT_FORM:
      return {
        ...state,
        employmentFormData: { ...state.employmentFormData, ...action.payload },
      };
    case CDX_ACTIONS.SET_INCOME_FORM:
      return {
        ...state,
        incomeFormData: { ...state.incomeFormData, ...action.payload },
      };

    case CDX_ACTIONS.SUBMIT_LICENSE_PLATE_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSubmitSuccess: true,
        apiError: null,
        error: null,
        licensePlateInfoResponse: action.payload,
        manualLicensePlateInfoForm: {
          year: action.payload?.year ?? '',
          make: action.payload?.make ?? '',
          model: action.payload?.model ?? '',
          estimatedMileage: state?.licensePlateInfoForm?.estimatedMileageRange,
          currentMonthlyPayment: state?.licensePlateInfoForm?.currentMonthlyPayment,

        },
      };
    case CDX_ACTIONS.SUBMIT_CREATE_CONTACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSubmitSuccess: true,
        apiError: null,
        error: null,
        createContactResponse: action.payload,
      };
    case CDX_ACTIONS.SET_ADDRESS_HISTORY:
      return {
        ...state,
        addressHistory: action.payload,
      };
    case CDX_ACTIONS.SET_ADDRESS_CONTACT_RESPONSE:
      return {
        ...state,
        addressContactResponse: action.payload,
      };
    case CDX_ACTIONS.SUBMIT_SOFTPULL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSubmitSuccess: true,
        softPullResponse: action.payload,
        apiError: null,
        error: null,
      };
    case CDX_ACTIONS.SET_OFFER_SELECTION:
      return {
        ...state,
        isLoading: false,
        isSubmitSuccess: true,
        offerSelectionFormData: action.payload,
        apiError: null,
        error: null,
      };
    case CDX_ACTIONS.SUBMIT_LICENSE_PLATE_INFO_START:
      return {
        ...state,
        isLoading: true,
        apiError: null,
        error: null,
      };
    case CDX_ACTIONS.GET_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        apiError: null,
        error: null,
        contactDetails: action.payload,
      };
    case CDX_ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
};
